// Desktop 1/2 depth menu accessibility and behavior
(function(){
  const topItems = document.querySelectorAll('.main-menu > li');
  if(!topItems.length) return;
  let openState = { li: null, sub: null, link: null };

  // Open submenu on hover/focus, close when leaving
  topItems.forEach(li => {
    const link = li.querySelector(':scope > a');
    const sub = li.querySelector(':scope > .sub-menu');
    if(!sub || !link) return;

    // ARIA attributes
    link.setAttribute('aria-haspopup','true');
    link.setAttribute('aria-expanded','false');

    function open(){
      // close others first
      if(openState.sub && openState.sub!==sub){ openState.sub.style.display='none'; openState.link?.setAttribute('aria-expanded','false'); }
      sub.style.display='block'; link.setAttribute('aria-expanded','true');
      openState = { li, sub, link };
    }
    function close(){ sub.style.display='none'; link.setAttribute('aria-expanded','false'); if(openState.sub===sub){ openState = { li:null, sub:null, link:null }; } }

    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', close);

    link.addEventListener('focus', open);
    sub.addEventListener('focusin', open);
    sub.addEventListener('focusout', (e)=>{
      if(!sub.contains(e.relatedTarget)) close();
    });

    // Keyboard: Enter/Space toggles; Esc closes
    link.addEventListener('keydown', e=>{
      if(e.key==='Enter' || e.key===' ') { e.preventDefault();
        const visible = sub.style.display==='block'; visible ? close() : open();
      }
      if(e.key==='Escape'){ close(); link.focus(); }
    });
    sub.addEventListener('keydown', e=>{ if(e.key==='Escape'){ e.stopPropagation(); close(); link.focus(); } });

    // Click to toggle for touch/mouse
    link.addEventListener('click', e=>{
      const visible = sub.style.display==='block';
      if(!visible){ e.preventDefault(); open(); }
      // if visible, allow navigation on second click
    });
  });

  // Close when clicking outside
  document.addEventListener('click', (e)=>{
    if(!openState.sub) return;
    if(!openState.li.contains(e.target)){
      openState.sub.style.display='none';
      openState.link?.setAttribute('aria-expanded','false');
      openState = { li:null, sub:null, link:null };
    }
  });
})();
